import { render } from "./ObligationCard.vue?vue&type=template&id=5e468d27&scoped=true&ts=true"
import script from "./ObligationCard.vue?vue&type=script&lang=ts"
export * from "./ObligationCard.vue?vue&type=script&lang=ts"

import "./ObligationCard.vue?vue&type=style&index=0&id=5e468d27&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e468d27"]])

export default __exports__